import { faker } from '@faker-js/faker';

import type { AdditionalUploadsPostResponse } from '../types/AdditionalUploadsPostResponse';

export function createAdditionalUploadsPostResponse(
  data: NonNullable<Partial<AdditionalUploadsPostResponse>> = {}
): NonNullable<AdditionalUploadsPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
